<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('application.patent.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
          <span class="front_loc">{{ $t('application.title') }} > </span>
          <span class="middle_loc">{{ $t('application.patent.title2') }} > </span>
          <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <v-layout class="step_wrapper type3">
            <v-flex class="step_box step01">
              <h2>{{ $t('application.patent.fields.step_01') }}</h2>
              <p v-html="$t('application.patent.fields.select_type_and_input')"></p>
            </v-flex>
            <v-flex class="step_box step02">
              <h2>{{ $t('application.patent.fields.step_02') }}</h2>
              <p>{{ $t('application.patent.fields.write_application') }}</p>
            </v-flex>
            <v-flex class="step_box step03">
              <h2>{{ $t('application.patent.fields.step_03') }}</h2>
              <p>{{ $t('application.patent.fields.attach_file(s)') }}</p>
            </v-flex>
            <v-flex class="step_box step04">
              <h2>{{ $t('application.patent.fields.step_04') }}</h2>
              <p>{{ $t('application.patent.fields.review_submit') }}</p>
            </v-flex>
            <v-flex class="active step_box step05">
              <h2>{{ $t('application.patent.fields.step_05') }}</h2>
              <p>{{ $t('application.patent.fields.payment') }}</p>
            </v-flex>
          </v-layout>

          <payment
            :payments.sync="paymentList"
            :receipt_no="receipt_no"
            :payment_history_seq="payment_history_seq"
            :query="$route.query"
          >
          </payment>

        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import Payment from '@/components/layout/Payment'

export default {
  name : 'PatentStep5',
  components :{
    Payment
  },
  data () {
    return {
      receipt_no : '',
      payment_history_seq: null,
      paymentList: []
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.receipt_no = this.$route.params.receipt_no
    this.fnGetPaymentList()
  },
  methods: {
    fnGetPaymentList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/payments',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = i + 1
            }
            this.paymentList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetPaymentList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    }

  }
}
</script>